<div id="loader" *ngIf="isLoader">
    <div id="shadow"></div>
    <div id="box"></div>
    <h4><b>Loading..</b></h4>
</div>
<div *ngIf="body">
    <mat-card style="background: transparent;">
        <mat-card class="card_style">

            <div>

                <div style="text-align: center; padding-top: 50px;">

                    <h1 style="margin-top: -18px;"><b>Market Study</b></h1>

                </div>
            </div>





            <div style="text-align:left;">
                <div>
                    <div style="margin-bottom: 2%;">
                        <img class="excel-button" src="https://cdn-icons-png.flaticon.com/128/732/732220.png" width="35"
                            height="35" (click)="excelExport()">
                    </div>
                    <div class="d-flex mb-3">
                    <div class="filter-dropdown">
                        <label class="label-filter" style="font-weight: 400; font-size: 14px;" for="">Industry Type:</label>
                        <ng-select placeholder="Select Industry Type" class="me-3" [items]="industry_type" (change)="industrySelected()" [(ngModel)]="search_filter.industry_type" bindLabel="name" bindValue="name"></ng-select>
                    </div>
                    <div class="filter-dropdown">
                        <label class="label-filter" style="font-weight: 400;font-size: 14px;" for="">Country:</label>
                        <ng-select placeholder="Select Country" class="me-3" [items]="country_drop" (change)="countrySelected()" [(ngModel)]="search_filter.marketing_country_id" bindLabel="name" bindValue="_id"></ng-select>
                    </div>
                    <div class="filter-dropdown">
                        <label class="label-filter" style="font-weight: 400;font-size: 14px;" for="">State:</label>
                        <ng-select placeholder="Select Country" class="me-3" [items]="statedrop" (change)="stateSelected()" [(ngModel)]="search_filter.marketing_state_id" bindLabel="name" bindValue="_id"></ng-select>
                    </div>
                    <div class="filter-dropdown">
                        <label class="label-filter" style="font-weight: 400;font-size: 14px;" for="">Area:</label>
                        <ng-select placeholder="Select Country" class="me-3" [items]="areadrop" (change)="areaSelected()" [(ngModel)]="search_filter.marketing_area_id" bindLabel="name" bindValue="_id"></ng-select>
                    </div>
                    <div class="filter-dropdown">
                        <label class="label-filter" style="font-weight: 400;font-size: 14px;" for="">Customer:</label>
                        <input type="text" [(ngModel)]="search_filter.customer_name" (ngModelChange)="customerSelected()" class="form-control me-3">
                    </div>
                    <div class="filter-dropdown">
                        <label class="label-filter ms-3" style="font-weight: 400;font-size: 14px;" for="">Type:</label>
                        <input type="text" [(ngModel)]="search_filter.customer_type" (ngModelChange)="customerSelected()" class="form-control ms-3">
                    </div>
                     </div>

                    <div class="table-responsive">
                        <!-- <table class="table" id="MarketStudy">
                            <thead >
                                <tr>

                                    <th scope="col" style="width: 40%;">Industry Type</th>
                                    <th scope="col" style="width: 40%;">Country</th>
                                    <th scope="col" style="width: 40%;">Latitude</th>
                                    <th scope="col" style="width: 40%;">Longitude</th>
                                    <th scope="col" style="width: 40%;">Customer</th>
                                    <th scope="col" style="width: 40%;">Whatsapp Number</th>
                                    <th scope="col" style="width: 40%;">Nationality</th>
                                    <th scope="col" style="width: 40%;">No Of Painters In Shop</th>
                                    <th scope="col" style="width: 60%;">Shop Old</th>
                                    <th scope="col" style="width: 60%;">Current Supplier</th>
                                    <th scope="col" style="width: 40%;">Is Painter Wear Supplier Tshirt</th>
                                    <th scope="col" style="width: 40%;">Tshirt Supplier Name</th>
                                    <th scope="col" style="width: 40%;">Present Major Wood Coating Brands In Doha</th>
                                    <th scope="col" style="width: 40%;">Is Use Of Premium Paints</th>
                                    <th scope="col" style="width: 40%;">Premium Paint Brand Name</th>
                                    <th scope="col" style="width: 40%;">Paint System</th>
                                    <th scope="col" style="width: 40%;"> Sealer Consumption In Month</th>
                                    <th scope="col" style="width: 40%;">Primer Consumption In Month</th>
                                    <th scope="col" style="width: 40%;">Stain Purchase In Month</th>
                                    <th scope="col" style="width: 40%;">Thinner Consumption In Month</th> 
                                    <th scope="col" style="width: 40%;">Type Of Abrasive Using</th>
                                    <th scope="col" style="width: 40%;">Abrasive Brand</th>
                                    <th scope="col" style="width: 40%;">Wood Paints Delivery Time To Carpentry Shop</th>

                                    <th scope="col" style="width: 40%;">Technical Support From Paint Suppliers</th>
                                    <th scope="col" style="width: 40%;">Payment Term With Supplier</th>                              
                                    <th scope="col" style="width: 40%;">Credit Period</th>
                                    <th scope="col" style="width: 40%;">Mas Paints Or Other Competitors Invoice</th>
                                    <th scope="col" style="width: 40%;">Price List Of Competitors</th>
                                  
                                    <th scope="col" style="width: 40%;">Monthly Purchase Volume</th>
                                    <th scope="col" style="width: 40%;">Remarks</th>
                                    <th scope="col" style="width: 40%;">Created By</th>

                                </tr>
                            </thead>
                            <tbody  >
                                <ng-container *ngFor="let employee of output">
                                    <tr>
                                        <td>{{ employee.industry_type}}</td>
                                        <td>{{ employee.country}}</td>
                                        <td>{{ employee.location.latitude}}</td>
                                        <td>{{ employee.location.longitude }}</td>
                                        <td>{{ employee.customer_name }}</td>
                                        <td>{{ employee.whatsapp_number }}</td>
                                        <td>{{ employee.owners_nationality }}</td>
                                        <td>{{ employee.no_of_painters_in_shop }}</td>
                                        <td>{{ employee.shop_old}}{{space}}{{employee.shop_old_uom}}</td>
                                        <td>{{ employee.current_supplier_name}}</td>
                                        <td>{{ employee.is_painter_wear_supplier_t_shirt }}</td>
                                       

                                        <td>{{ employee.t_shirt_supplier_name }}</td>
                                        <td>{{ employee.present_major_wood_coating_brands_in_doha }}</td>

                                        <td>{{ employee.is_use_of_premium_paints }}</td>
                                        <td>{{ employee.premium_paint_brand_name }}</td>
                                        <td>{{ employee.paint_system }}</td>
                                        <td>{{ employee.sealer_consumption_in_month}}{{space}}{{employee.sealer_consumption_uom}}</td>
                                        <td>{{ employee.primer_consumption_in_month }}{{space}}{{ employee.primer_consumption_uom }}</td>
                                        <td>{{ employee.stain_purchase_in_month }}{{space}}{{ employee.stain_purchase_uom }}</td>

                                        <td>{{ employee.thinner_consumption_in_a_month }}{{space}}{{ employee.thinner_consumption_uom}}</td>

                                        <td>{{ employee.type_of_abrasive_using}}</td>
                                        <td>{{ employee.abrasive_brand}}</td>
                                        <td>{{ employee.wood_paints_delivery_time_to_carpentry_shop }}{{space}}Hrs</td>

                                        <td>{{ employee.is_get_technical_support_from_paint_suppliers }}</td>
                                        <td>{{ employee.payment_term_with_supplier }}</td>
                                        <td>{{ employee.credit_period}}{{space}}Days</td>
                                        <td>{{ employee.mas_paints_or_other_competitors_invoice }}</td>
                                        <td>{{ employee.price_list_of_competitors }}</td>
                                       
                                        <td>{{ employee.monthly_purchase_volume}}</td>
                                        <td>{{ employee.remarks}}</td>
                                        <td>{{ employee.created_by_name}}</td>

                                    </tr>
                                </ng-container>
                            </tbody>
                        </table> -->
                        <table class="table" id="MarketStudy">
                            <thead>
                                <tr>

                                    <th scope="col" style="width: 40%;">Industry Type</th>
                                    <th scope="col" style="width: 40%;">Country</th>
                                    <th scope="col" style="width: 40%;" >State</th>
                                    <th scope="col" style="width: 40%;" >Area</th>
                                    <th scope="col" style="width: 40%;">Latitude</th>
                                    <th scope="col" style="width: 40%;">Longitude</th>
                                    <th scope="col" style="width: 40%;">Customer</th>
                                    <th scope="col" style="width: 40%;">Type</th>
                                    <th scope="col" style="width: 40%;">Customer Category</th>
                                    <th scope="col" style="width: 40%;">Whatsapp Number</th>
                                    <th scope="col" style="width: 40%;">Owners Nationality</th>
                                    <th scope="col" style="width: 40%;">No Of Painters In Shop</th>
                                    <th scope="col" style="width: 40%;">Shop Old</th>
                                    <th scope="col" style="width: 40%;">Delivery Duration</th>
                                    <th scope="col" style="width: 60%;">Current Supplier 1</th>
                                    <th scope="col" style="width: 60%;">Current Supplier 2</th>
                                    <th scope="col" style="width: 60%;">Current Supplier 3</th>
                                    <th scope="col" style="width: 60%;">Mixing Machine Brand</th>
                                    <th scope="col" style="width: 60%;">Body filler Brand</th>
                                    <th scope="col" style="width: 60%;">Monthly Bussiness</th>
                                    <th scope="col" style="width: 60%;">No of Staffs</th>
                                    <th scope="col" style="width: 60%;">Sales Staff</th>
                                    <th scope="col" style="width: 60%;">No of Cars Monthly</th>
                                    <th scope="col" style="width: 60%;">No of Panels Monthly</th>
                                    <th scope="col" style="width: 60%;">No of Paint Booth</th>
                                    <th scope="col" style="width: 60%;">Color Mixer</th>
                                    <th scope="col" style="width: 60%;">Existing Credit Terms</th>
                                    <th scope="col" style="width: 60%;">Payment Behaviour</th>
                                    <th scope="col" style="width: 60%;">Abrasive Opportunity</th>
                                    <!-- <th scope="col" style="width: 60%;">Created At</th>
                                    <th scope="col" style="width: 60%;">Updated At</th> -->
                                    <th scope="col" style="width: 60%;">Created By</th>
                                    <th scope="col" style="width: 60%;">Type Of Work</th>

                                    <!------------------------new fields------------------>
                                    <th scope="col" style="width: 60%;">2K Primer Brand</th>
                                    <th scope="col" style="width: 60%;">1K Primer Brand</th>
                                    <th scope="col" style="width: 60%;">Clear Coat Brand</th>
                                    <th scope="col" style="width: 60%;">NC Thinner Brand</th>
                                    <th scope="col" style="width: 60%;">2K Thinner Brand</th>
                                    <th scope="col" style="width: 60%;">Abrasive Brand</th>



                                </tr>
                            </thead>
                            <tbody class="table-bordered">
                                <ng-container *ngFor="let employee of output">
                                    <tr>
                                        <td>{{ employee?.industry_type}}</td>
                                        <td>{{ employee?.marketing_country?.name}}</td>
                                        <td >{{ employee?.marketing_state?.name}}</td>
                                        <td >{{ employee?.marketing_area?.name}}</td>
                                        <td>{{ employee?.latitude}}</td>
                                        <td>{{ employee?.longitude}}</td>
                                        <td>{{ employee?.customer_name}}</td>
                                        <td>{{ employee?.customer_type}}</td>
                                        <td>{{ employee?.customer_category}}</td>
                                        <td>{{ employee?.whatsapp_number}}</td>
                                        <td>{{ employee?.owners_nationality}}</td>
                                        <td>{{ employee?.no_of_painters}}</td>
                                        <td>{{ employee?.shop_old}}</td>
                                        <td>{{ employee?.delivery_duration}}</td>
                                        <td>{{ employee?.current_supplier_name_1}}</td>
                                        <td>{{ employee?.current_supplier_name_2}}</td>
                                        <td>{{ employee?.current_supplier_name_3}}</td>
                                        <!-- <td>data</td> -->
                                        <td>
                                         <div *ngFor="let brand of employee?.mixing_machine_brand; let i = index">
                                          <!-- {{ brand.replace('[', '').replace(']', '') }} -->
                                             {{ i + 1 }}. {{ brand.replace('[', '').replace(']', '') }},
                                         </div>
                                        </td>

                                        <!-- <td>
                                            <div *ngFor="let name of employee?.current_supplier">
                                                {{name}}
                                            </div>
                                        </td> -->
                                        <td>
                                            <div *ngFor="let filler of employee?.body_filler_brand">
                                                {{filler?.name}} 
                                                <span *ngIf="filler.avgMonthlyVolume"> - {{filler?.avgMonthlyVolume}}</span> 
                                                <span *ngIf="filler.price"> - {{filler?.price}}</span>
                                                <div style="height: 15px;"></div>
                                            </div>
                                        </td>
                                        <td>{{employee?.monthly_bussiness}}</td>
                                        <td>{{employee?.no_of_staffs}}</td>
                                        <td>{{employee?.sales_staff}}</td>
                                        <td>{{employee?.no_of_cars_monthly}}</td>
                                        <td>{{employee?.no_of_panels_monthly}}</td>
                                        <td>{{employee?.no_of_paint_booths}}</td>
                                        <td>{{employee?.color_mixer}}</td>
                                        <td>{{employee?.existing_credit_terms}}</td>
                                        <td>{{employee?.payment_behaviour}}</td>
                                        <td>{{employee?.abrasive_opertunity}}</td>
                                        <!-- <td>{{employee?.createdAt}}</td>
                                        <td>{{employee?.updatedAt}}</td> -->
                                        <td>{{employee?.created_by?.employee_name}}</td>
                                        <td>{{employee?.type_of_work}}</td>

                                        <!------------------------new fields------------------>
                                    
                                        <td>
                                            <div *ngFor="let filler of employee?.two_k_primer_brand">
                                                {{filler?.name}} 
                                                <span *ngIf="filler.avgMonthlyVolume"> - {{filler?.avgMonthlyVolume}}</span> 
                                                <span *ngIf="filler.price"> - {{filler?.price}}</span>
                                                <div style="height: 15px;"></div>
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngFor="let filler of employee?.one_k_primer_brand">
                                                {{filler?.name}} 
                                                <span *ngIf="filler.avgMonthlyVolume"> - {{filler?.avgMonthlyVolume}}</span> 
                                                <span *ngIf="filler.price"> - {{filler?.price}}</span>
                                                <div style="height: 15px;"></div>
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngFor="let filler of employee?.clear_coat_brand">
                                                {{filler?.name}} 
                                                <span *ngIf="filler.avgMonthlyVolume"> - {{filler?.avgMonthlyVolume}}</span> 
                                                <span *ngIf="filler.price"> - {{filler?.price}}</span>
                                                <div style="height: 15px;"></div>
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngFor="let filler of employee?.nc_thinner_brand">
                                                {{filler?.name}} 
                                                <span *ngIf="filler.avgMonthlyVolume"> - {{filler?.avgMonthlyVolume}}</span> 
                                                <span *ngIf="filler.price"> - {{filler?.price}}</span>
                                                <div style="height: 15px;"></div>
                                            </div>
                                        </td> 
                                        <td>
                                            <div *ngFor="let filler of employee?.two_k_thinner_brand">
                                                {{filler?.name}} 
                                                <span *ngIf="filler.avgMonthlyVolume"> - {{filler?.avgMonthlyVolume}}</span> 
                                                <span *ngIf="filler.price"> - {{filler?.price}}</span>
                                                <div style="height: 15px;"></div>
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngFor="let filler of employee?.abrasive_brand">
                                                {{filler?.name}} 
                                                <span *ngIf="filler.avgMonthlyVolume"> - {{filler?.avgMonthlyVolume}}</span> 
                                                <span *ngIf="filler.price"> - {{filler?.price}}</span>
                                                <div style="height: 15px;"></div>
                                            </div>
                                        </td>
       

                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>